/* global WC */
import OriginalEventText from '@shared-vue-components/components/asiagoit-cancel-postpone-event/OriginalEventText.vue'
import {NConfigProvider} from 'naive-ui'
import {createApp, h, Suspense} from 'vue'

//
;(() => {
  if (WC.idMenu !== 34 || WC.idArticolo == null) {
    return
  }

  const app = createApp({
    setup() {
      return () =>
        h(
          NConfigProvider,
          {
            preflightStyleDisabled: true,
          },
          h(
            Suspense,
            {timeout: 0},
            h(OriginalEventText, {
              articleId: WC.idArticolo,
            })
          )
        )
    },
  })

  const articleBody = document.querySelector('.f-art__body')

  if (!articleBody) {
    return
  }

  const articleImage = articleBody.querySelector('.image')
  const element = document.createElement('div')
  element.setAttribute('data-cms-vue-component', 'cancel-postpone-event-text')

  if (articleImage) {
    articleImage.after(element)
  } else {
    articleBody.prepend(element)
  }

  document.addEventListener('cmsVueComponentsReady', () => {
    app.mount(element)
  })
})()
